export default __webpack_public_path__ + "static/uk_list_banner-8aea97610ef779a7b5b285f1b49ca3cf.webp";